import React, { PureComponent, Fragment } from 'react';
import { bool, string, func } from 'prop-types';
import { reduxForm } from 'redux-form';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import { LAST_BILL_QUERY } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';

import AuthForm from '../../components/AuthForm';

class LastBillQuery extends PureComponent {
  render() {
    return (
      <Fragment>
        <AuthForm
          documentType={this.props.documentType}
          submitFailed={this.props.submitFailed}
          invalid={this.props.invalid}
          handleSubmit={this.props.handleSubmit}
          onGoToHome={this.props.onGoToHome}
          description={message('PublicLastBill:lastBillDescription')}
        />
      </Fragment>
    );
  }
}

LastBillQuery.propTypes = {
  handleSubmit: func.isRequired,
  invalid: bool,
  submitFailed: bool,
  documentType: string,
  onGoToHome: func.isRequired
};

export default WithLoading(props => props.loading)(
  reduxForm({ form: LAST_BILL_QUERY })(Radium(LastBillQuery))
);
